import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";
import checkFill from "../assets/img/check-fill.png";

export type WisdomSubmitPhase = "submitting" | "submitted";

interface WisdomSubmitModalProps extends ModalProps {
  phase: WisdomSubmitPhase;
}

const WisdomSubmitModal = ({ phase, ...props }: WisdomSubmitModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      backdrop="static"
      keyboard={false}
      centered
      className="wisdomSubmitModal"
    >
      <Modal.Body>
        {phase === "submitting" ? (
          <>
            <div className="wisdomSubmitModal__spinner" aria-hidden="true">
              {Array.from({ length: 12 }, (_, index) => (
                <span key={index} />
              ))}
            </div>
            <p className="wisdomSubmitModal__title">SUBMITTING YOUR WISDOM</p>
          </>
        ) : (
          <>
            <img className="wisdomSubmitModal__check" src={checkFill} alt="" />
            <p className="wisdomSubmitModal__title">
              YOUR WISDOM
              <br />
              HAS BEEN SUBMITTED SUCCESSFULLY!
            </p>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WisdomSubmitModal;
